export default __webpack_public_path__ + "static/media/Montserrat-Bold.0af89c10.woff2";